import CONSTANTS from '@/constants'

const { VOUCHERS } = CONSTANTS

export const vouchersHydratation = certificationVouchersCollection => {
  certificationVouchersCollection.forEach(voucher => {
    voucher.product_type = 'certificate'
    voucher.addOn = false
    voucher.addOnChecked = false
    switch (voucher.merchant_id) {
      case VOUCHERS.ICCA:
        voucher.version = 'v1.0'
        voucher.nameLong = 'INE Certified Cloud Associate Exam Voucher'
        voucher.descriptionOld = `The INE Certified Cloud Associate (ICCA) exam is an entry-level certification 
              designed for anyone interested in becoming part of the Cloud conversation within their organization. 
              This certification covers Cloud Concepts, Cloud Services, and Cloud Security and 
              Regulatory Compliance through real-world, multiple-choice questions and hands-on lab challenges. 
              The ICCA covers general cloud concepts and how they are implemented in three of the largest 
              cloud provider platforms, including AWS, Azure, and GCP Cloud Platform. 
              If you want to begin your journey in cloud, increase your knowledge of multiple cloud platforms, 
              or become part of the cloud conversation, this certification is for you.`
        voucher.price = `$${voucher.price_cents / 100}`
        break
      case VOUCHERS.EJPT:
        voucher.nameLong = 'Junior Penetration Tester Exam Voucher'
        voucher.descriptionOld = `The Jr. Penetration Tester exam (eJPT) validates that the individual 
              has the knowledge and skills required to fulfill a role as an entry-level penetration tester. 
              This certification covers Assessment Methodologies and Enterprise Auditing with Host, 
              Network, and Web Application Penetration Testing. This exam is designed to be the first milestone certification 
              for someone with little to no experience in cybersecurity, simulating the skills utilized during a 
              real-world engagement. This exam truly shows yourself and your employer that 
              you have what it takes to be part of a winning penetration testing team.`
        voucher.price = `$${voucher.price_cents / 100}`
        break
      case VOUCHERS.EDA:
        voucher.nameLong = 'Enterprise Defense Associate Exam Voucher'
        voucher.descriptionOld = `The Enterprise Defense Administrator (eEDA) exam is designed for professionals 
              that are just starting their defensive cybersecurity or security engineering journey. 
              This certification covers Secure Engineering Fundamentals, Governance Risk and Compliance, Identity and 
              Access Management, and Security Administration. This exam is designed to give you the skills you'll need to 
              succeed as a Defensive Security Engineer, all while testing your abilities in a hands-on testing environment. 
              While this certification is the perfect first milestone certification for someone with little to no experience 
              in cybersecurity, a background in IT is highly recommended.`
        voucher.price = `$${voucher.price_cents / 100}`
        break
      default:
        break
    }
  })
}
